import { Card, EventAvailableOutlinedIcon, Flex, PaperSection, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { useAdminExamLocationDetail } from '../../providers';

export default function RetiredRoomInfo() {
  const { examRoomInfo } = useAdminExamLocationDetail();

  return (
    <PaperSection title='ข้อมูลการยกเลิกสถานที่สอบ'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          p: theme.spacing(6),
        })}
      >
        <Card
          elevation={0}
          sx={(theme) => ({
            border: '1px solid',
            borderColor: theme.palette.grey[300],
            borderRadius: theme.shape.rounded(2),
            px: theme.spacing(4),
            py: theme.spacing(3),
          })}
        >
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(2),
              borderLeft: '4px solid',
              borderColor: theme.palette.grey[500],
              pl: theme.spacing(3),
            })}
          >
            <Flex sx={(theme) => ({ gap: theme.spacing(1), alignItems: 'center' })}>
              <EventAvailableOutlinedIcon
                sx={(theme) => ({
                  fontSize: theme.spacing(4),
                  color: 'text.secondary',
                })}
              />
              <Text sx={{ color: 'text.secondary' }}>วันที่ยกเลิก:</Text>
              <Text color='text.secondary'>{formatDateTime(examRoomInfo.retiredAt) ?? '-'}</Text>
            </Flex>
            <Flex sx={(theme) => ({ gap: theme.spacing(1), flexDirection: 'column' })}>
              <Flex>
                <Text variant='body1Semibold'>สาเหตุที่ยกเลิกการใช้งาน:</Text>
              </Flex>
              <Flex>
                <Text
                  sx={{
                    wordBreak: 'break-word',
                  }}
                >
                  {examRoomInfo.retiredRemark ?? '-'}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Card>
      </Flex>
    </PaperSection>
  );
}
